import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-fn-mobile-table-header',
  templateUrl: './fn-mobile-table-header.component.html',
  styleUrls: ['./fn-mobile-table-header.component.scss']
})
export class FnMobileTableHeaderComponent {
  @Input() titleTranslate = "IP.SIDENAV.OPTIONS.FINANCE";

}
